<template lang="pug">
  #appConversasStatus
    el-card(shadow="hover")
      p.bolder Filtros
      el-row.margin-left
        el-col(:xs="12" :lg="7" :xl ="7" :sm="10")
          InputEntreDatas(
            placeholder="Período"
            :calendario="calendario"
            v-model="calendario"
          )
        el-col(:xs="24" :lg="9" :xl ="8" :sm="13")
          p Assunto
          el-select(
            style="width: 24rem"
            v-model="filtro.assunto"
            filterable
            clearable
            multiple
            collapse-tags
          )
            el-option(
              v-for="item in assuntos"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
        el-col(:xs="24" :lg="8" :xl ="8" :sm="12")
          p Responsável
          el-select(
            v-model="filtro.idsResponsaveis"
            multiple
            collapse-tags
            filterable
            clearable
          )
            el-option(
              v-for="item in responsaveis"
              :key="item.pessoa.pessoaFisica.id"
              :label="item.pessoa.pessoaFisica.nome"
              :value="item.pessoa.pessoaFisica.id"
            )
      el-row.margin.float
        el-button(
          type="text"
          size="medium"
          round
          @click="handleLimpar"
        ) Limpar
        el-button(
          type="primary"
          size="medium"
          round
          @click="handleFiltrar"
        ) Filtrar
    el-card#graficoId.content-dados
      GraficoStatus(
        v-if="acaoCondicao"
        :dadosLabels="dadosFiltro"
      )
      app-listagem-conversas(
        v-else
        :data="dadosFiltro"
        :colunaChave="nomeColuna"
        :totalDeConversas="totalDeConversas"
        emptyData = "Não há dados registrados"
      )
    el-row
      BotaoSelecionar.center(
        @btn-0="selecionar('acao-1')"
        @btn-1="selecionar('acao-2')"
        botao0="Gráficos"
        botao1="Tabela"
      )
    el-row.botao-exportar.float
      BotaoExportarSelecionado(
        @exportar-img-grafico="exportarImgGrafico"
        :dadosFiltro="filtro"
        :selecionadoCondicao="acaoCondicao"
        :disabled="botaoExportarDesligado"
        tab="status"
        :carregando="isLoading"
      )
</template>

<script>
import { mapActions } from 'vuex'
import domtoimage from 'dom-to-image'
import moment from 'moment'

import AppNotificacao from '@/components/mixins/AppNotificacao'
import InputEntreDatas from '../InputEntreDatas'
import AppListagemConversas from '../AppListagemConversas'
import BotaoSelecionar from '../BotaoSelecionar'
import BotaoExportarSelecionado from '../BotaoExportarSelecionado'
import GraficoStatus from '../graficos/GraficoStatus'
import { assuntos } from './nomesEstaticos'

export default {
  name: 'AppConversasStatus',
  mixins: [
    AppNotificacao
  ],
  components: {
    InputEntreDatas,
    AppListagemConversas,
    BotaoSelecionar,
    BotaoExportarSelecionado,
    GraficoStatus
  },
  data () {
    return {
      nomeColuna: 'Status',
      acaoCondicao: true,
      calendario: [],
      responsaveis: [],
      assuntos: [],
      dadosFiltro: [],
      isLoading: false,
      botaoExportarDesligado: false,
      filtro: {
        assunto: [],
        idsResponsaveis: [],
        dataInicio: null,
        dataFim: null
      },
      totalDeConversas: 0,
      totalFiltrado: 0
    }
  },
  methods: {
    ...mapActions({
      findResponsaveis: 'filtros/findResponsaveis',
      filtrarPorStatus: 'filtros/filtrarPorStatus'
    }),

    selecionar (acao) {
      if (acao === 'acao-1') {
        this.acaoCondicao = true
      } else if (acao === 'acao-2') {
        this.acaoCondicao = false
      }
    },

    exportarImgGrafico () {
      this.isLoading = true
      const dataConsulta = moment().format('DD-MM-YYYY_hh:mm:ss')
      domtoimage.toBlob(document.getElementById('graficoId'))
        .then((blob) => {
          window.saveAs(blob, `Grafico_Status_${dataConsulta}.png`)
          this.isLoading = false
        })
    },

    seNaoHaDados () {
      if (this.dadosFiltro.every(elem => elem.quantidade === 0)
      ) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'Nenhuma conversa encontrada neste período.')
        this.botaoExportarDesligado = true
      } else {
        this.botaoExportarDesligado = false
      }
    },

    handleLimpar () {
      this.calendario = []
      this.filtro = {
        dataInicio: null,
        dataFim: null,
        assunto: [],
        idsResponsaveis: []
      }
      this.getFiltroStatus().then(() => this.seNaoHaDados())
    },

    async handleFiltrar () {
      if (
        this.calendario <= 0 &&
        this.filtro.assunto <= 0 &&
        this.filtro.idsResponsaveis <= 0
      ) {
        this.dadosFiltro = await this.filtrarPorStatus()
        this.seNaoHaDados()
      } else if ((
        this.calendario <= 0 &&
        !this.filtro.assunto <= 0 &&
        !this.filtro.idsResponsaveis <= 0
      )) {
        this.dadosFiltro = await this.filtrarPorStatus(this.filtro)
        this.seNaoHaDados()
      } else {
        this.filtro.dataInicio = moment(this.calendario[0]).format('yyyy-MM-DD')
        this.filtro.dataFim = moment(this.calendario[1]).format('yyyy-MM-DD')
        this.dadosFiltro = await this.filtrarPorStatus(this.filtro)
        this.seNaoHaDados()
      }
      let totalFiltrado = 0
      for (let i = 0; i < this.dadosFiltro.length; i++) {
        totalFiltrado += this.dadosFiltro[i].quantidade
      }
      this.totalDeConversas = totalFiltrado
      if (this.totalDeConversas === 0) {
        this.dadosFiltro = []
      }
    },

    async getResponsaveis () {
      this.responsaveis = await this.findResponsaveis()
    },

    async getFiltroStatus () {
      this.totalDeConversas = 0
      this.dadosFiltro = await this.filtrarPorStatus()
      for (let i = 0; i < this.dadosFiltro.length; i++) {
        this.totalDeConversas += this.dadosFiltro[i].quantidade
      }
    }
  },
  created () {
    this.assuntos = assuntos
  },
  mounted () {
    this.getResponsaveis()
    this.getFiltroStatus()
  }
}
</script>

<style lang="scss" scoped>

  .margin {
    margin: 1.5rem 2rem 1.5rem;
  }

  .margin-left {
    margin-left: 0.3rem;
  }

  .botao-exportar {
    margin: 1.5rem 2rem 0.5rem;
  }

  .float {
    float: right;
  }

  .center {
    display:flex;
    position:absolute;
    left: auto;
    right: 45%;
    top: -1.3rem;
  }

  .bolder {
    font-weight: bolder;
  }

  .container-tabela{
    display: flex;
    place-content: flex-end;
    margin-top: 80px;
  }

  /deep/ .cell {
    color: #424242;
  }

  .content-dados {
    margin-top: 1rem ;
    height: 24rem;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_ouvidoria/components/conversas/AppConversasStatus.vue